import { render } from 'preact';
import { App } from './App';
import './styles.css';

function getWidgetId(): string | null {
  const url = new URL(window.location.href);

  const pathMatch = url.pathname.match(/\/w\/([a-f0-9-]+)/i);
  if (pathMatch) return pathMatch[1];

  const param = url.searchParams.get('wid');
  if (param) return param;

  const el = document.querySelector<HTMLElement>('[data-widget-id]');
  if (el) return el.dataset.widgetId || null;

  return null;
}

function getPrefillContact(): { name?: string; email?: string; phone?: string } {
  const url = new URL(window.location.href);

  let name = url.searchParams.get('name') || undefined;
  let email = url.searchParams.get('email') || undefined;
  let phone = url.searchParams.get('phone') || undefined;

  if (!name || !email) {
    const el = document.querySelector<HTMLElement>('[data-widget-id]');
    if (el) {
      name = name || el.dataset.buyerName || undefined;
      email = email || el.dataset.buyerEmail || undefined;
      phone = phone || el.dataset.buyerPhone || undefined;
    }
  }

  return { name, email, phone };
}

function getRefCode(): string | undefined {
  const url = new URL(window.location.href);
  const ref = url.searchParams.get('ref')?.trim();
  if (ref) return ref;
  const el = document.querySelector<HTMLElement>('[data-widget-id]');
  return el?.dataset.ref ?? undefined;
}

function getSupportRegistration(): boolean {
  const url = new URL(window.location.href);
  const v = url.searchParams.get('supportRegistration');
  if (v != null && v !== '') {
    const lower = v.toLowerCase();
    if (lower === 'false' || lower === '0' || lower === 'no') return false;
    if (lower === 'true' || lower === '1' || lower === 'yes') return true;
  }
  const el = document.querySelector<HTMLElement>('[data-widget-id]');
  const d = el?.dataset.supportRegistration?.trim().toLowerCase();
  if (d != null && d !== '') {
    if (d === 'false' || d === '0' || d === 'no') return false;
    if (d === 'true' || d === '1' || d === 'yes') return true;
  }
  return true;
}

const widgetId = getWidgetId();

if (widgetId) {
  const prefill = getPrefillContact();
  const refCode = getRefCode();
  const supportRegistration = getSupportRegistration();
  render(<App widgetId={widgetId} prefillContact={prefill} refCode={refCode} supportRegistration={supportRegistration} />, document.getElementById('app')!);
} else {
  document.getElementById('app')!.innerHTML =
    '<div style="padding:2rem;text-align:center;color:#999">Missing widget ID. Use /w/:widgetId or ?wid=:widgetId</div>';
}
